import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { List, Ellipsis, SpinLoading, Tag, ErrorBlock } from 'antd-mobile';
import styled from 'styled-components';
import { getWorkOrderStatusData } from '../utils/helpers';

const WorkOrders = styled(List)`
	width: 100%;
`;

const Status = styled(Tag)`
`;

const Title = styled.div`
	margin: 0px 8px 0px 0px;
	display: inline-block;
	font-size: var(--adm-font-size-9);
	color: var(--adm-color-text);
`;

const Aircraft = styled.span`
	margin-right: 8px;
`;

const StatusWrapper = styled.div`
	display: flex;
	align-items: center;
	font-size: var(--adm-font-size-5);
	margin-bottom: 4px;
	margin-top: 4px;
`;

const SpinWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

function WorkOrdersList(props) {
	const {
		workOrders,
		loading
	} = props;
	const history = useHistory();

	function getList() {
		if (!workOrders.length) {
			return <ErrorBlock
				style={{ paddingTop: 12 }}
				title="No work orders found"
				description="Try new search?"
				status='empty'
			/>;
		}

		return <WorkOrders>
			{workOrders.map(wo => (
				<List.Item
					key={wo.id}
					title={<Title>{wo.nr || '-'}</Title>}
					description={<Ellipsis direction='end' rows={3} content={wo.description || '-'} />}
					onClick={() => history.push(`/work-order/${wo.id}`)}
					clickable
				>
					<StatusWrapper>
						<Aircraft>{wo.aircraft_registration || wo.item_description || '-'}</Aircraft>
						<Status color={getWorkOrderStatusData(wo.status).color}>
							{getWorkOrderStatusData(wo.status).text}
						</Status>
					</StatusWrapper>
				</List.Item>
			))}
		</WorkOrders>;
	}

	return (
		loading ? <SpinWrapper><SpinLoading style={{ '--size': '48px' }} /></SpinWrapper> : getList()
	);
}

export default WorkOrdersList;
